<template>
  <div class="component-container">
    <div class="second-edition" id="second-edition">
      <h3>KLNG Second Edition: Plants and Animals Live Here - Downloads and Resources</h3>
      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>

      <div class="presentations">
        <h4>Teacher Resources</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2FKLNG-2E_Activities_1-5_08212024.zip?alt=media&token=c2d937e2-2034-4c6c-9c3f-2ca6b5662123" target="_blank">Teacher Presentations: Activities 1 - 5</a> - Updated 8/21/2024</li>
          <li><a href="https://www.carolina.com/teacher-resources/Video/care-and-handling-of-pillbugs-video/tr11207.tr" target="_blank">Critters in the Classroom: Pill Bugs (Video)</a> - How to setup your classroom habitat</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>        
      </div>
      
      <div class="presentations">
        <h4>Student Journals &amp; Assessments</h4>
        <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1MwjUMzJsaIEJAI2raexO1AaBebrabj914NyflOCM60Y/copy" target="_blank">KLNG Second Edition: Plants and Animals Live Here Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/1m3tGNk_oIcruM6IufO112LziTyT9YC9V/view" target="_blank">KLNG Second Edition: Plants and Animals Live Here Student Journal Answer Key</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Ub6f4-viZ8tB7agLCCL4elLEUF0pSepbtczeL4dcy4U/copy" target="_blank">KLNG Second Edition: Plants and Animals Live Here Student Journal - SPANISH</a></li>
        </ul>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2FKLNG-2E_PostAssessment_05042022.pdf?alt=media&token=380e09d9-1b0f-44bd-a343-7cc11d15af22" target="_blank">KLNG Second Edition Post Assessment - Updated 6/8/2022</a></li>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2FKLNG-2E_Spanish_PostAssessment_06082022.pdf?alt=media&token=d6e3eb96-0f40-4e48-8ef2-cd07f8c5084d" target="_blank">KLNG Second Edition Post Assessment (Spanish) - Updated 6/8/2022</a></li>
        </ul>
      </div>
      
      <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>

        <ul>
          <li><a href="https://docs.google.com/presentation/d/1bZ84KvmhZaVCknoLRyXkc2VcyuHPVx-ESNjCGQF4rJA/copy" target="_blank">Living / Nonliving / What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/17x2jh4NIonkytgTmY6vdj0UXzH9rV-cEodQ7lZozdOw/copy" target="_blank">What We Think Humans and Living Things Need to Survive</a></li>
          <li><a href="https://docs.google.com/presentation/d/1A35hZtZLCGqw7ibpMxKUPL9wzHwNEcx_-SjKnAtQtrM/copy" target="_blank">Habitat Observation Log</a></li>
          <li><a href="https://docs.google.com/presentation/d/1ZVadY7ia0ATzphv2PVRw1PQQ1aEsu9tlFH17UcqIWTo/copy" target="_blank">Earthworm Anatomy and Movement</a></li>
          <li><a href="https://docs.google.com/presentation/d/1dWHLRrLOatsMW-W2JxOVw8XCQqlB4uTMGonIv-8Ba2g/copy" target="_blank">Investigating Worms Handout</a></li>
          <li><a href="https://docs.google.com/presentation/d/1vwhAdls1SKkz7cH8Yklt7WVndKZZwMui6Vdxyvng2lw/copy" target="_blank">Worm Viewer Observation Log</a></li>
          <li><a href="https://drive.google.com/file/d/181R7YuKcCs3adRykfOGQylvF1YtkVcWG/copy" target="_blank">Sorting Seeds</a></li>
          <li><a href="https://drive.google.com/file/d/12gBM2krTZK3tivGIMEyhUnPIeDMVdEUM/copy" target="_blank">Planting of Seeds (Handout)</a></li>
          <li><a href="https://drive.google.com/file/d/1PdVRYG3m16tKWo4FaUtrP-YXrxscU8Pe/copy" target="_blank">Watching Our Seeds Grow Observation Booklet</a></li>
          <li><a href="https://docs.google.com/presentation/d/1meJ9VFLb-oKVmXIYqG_eVAzozm5uoYHv2p3jPYQ2oYs/copy" target="_blank">Word Sort Cards - Lesson 4B</a></li>
          <li><a href="https://docs.google.com/presentation/d/1npqHynRcdjsoyTC1qKHQK3qqcIvg9OxGSC6xpbQhM9o/copy" target="_blank">Plant Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1WJkugM6mO3rJv4z6uyElSoCdLp3YWsI7aJj2UxZ8wJQ/copy" target="_blank">Word Sort Cards - Lesson 5B</a></li>
          <li><a href="https://docs.google.com/presentation/d/18xFvvjc_0MJ43rtA3hCSvvf3l3tffr-KBYe5tvlsyRU/copy" target="_blank">Human Impact Card Set</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="css" scoped>
.presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
}
ul {
  list-style: none;
}
.presentations a {
  margin-left: 40px;
}
li {
  margin-left: -40px;
}
.back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
}
.back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
}
</style>
